import { render, staticRenderFns } from "./IconHelp.vue?vue&type=template&id=37c4ad07&"
import script from "./IconHelp.vue?vue&type=script&lang=js&"
export * from "./IconHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37c4ad07')) {
      api.createRecord('37c4ad07', component.options)
    } else {
      api.reload('37c4ad07', component.options)
    }
    module.hot.accept("./IconHelp.vue?vue&type=template&id=37c4ad07&", function () {
      api.rerender('37c4ad07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconHelp.vue"
export default component.exports